import { selectTargetActor } from '../../actions/game/targetActor.actions'

const targetActorMiddleware = ({ getState, dispatch }) => next => (action) => {
    const { meta } = action
    const { targetActor } = meta || {}

    if (!targetActor) {
        return next(action)
    }

    switch (targetActor) {
        case 'checkSame': {
            const { targetActor: oldTargetActorState } = getState()
            const { payload: { actor } } = action
            if (actor && actor === oldTargetActorState) {
                return dispatch(selectTargetActor(''))
            }
            return next(action)
        }

        case 'checkDeath': {
            const { targetActor: targetActorState, actors } = getState()
            const selectedActor = actors.filter(actor => actor.ID === targetActorState)
            if (!selectedActor.length) {
                dispatch(selectTargetActor(''))
            }
            break
        }

        default: {
            return next(action)
        }
    }

    return next(action)
}

export default targetActorMiddleware
